import { createFileRoute } from "@tanstack/react-router";

import { BASE_URL, OG_VERSION } from "@/common/links";
import { AcceptableUseContent } from "@/landing/legal/AcceptableUseContent";
import { PAGE_META } from "@/landing/lib/page-meta";

export const Route = createFileRoute("/_steward/acceptable-use")({
  component: AcceptableUseContent,
  head: () => ({
    meta: [
      { title: PAGE_META["/acceptable-use"].title },
      {
        name: "description",
        content: PAGE_META["/acceptable-use"].description,
      },
      { property: "og:title", content: PAGE_META["/acceptable-use"].title },
      {
        property: "og:description",
        content: PAGE_META["/acceptable-use"].description,
      },
      {
        property: "og:image",
        content: `${BASE_URL}/og/acceptable-use.png?v=${OG_VERSION}`,
      },
      { name: "twitter:title", content: PAGE_META["/acceptable-use"].title },
      {
        name: "twitter:description",
        content: PAGE_META["/acceptable-use"].description,
      },
      {
        name: "twitter:image",
        content: `${BASE_URL}/og/acceptable-use.png?v=${OG_VERSION}`,
      },
    ],
    links: [{ rel: "canonical", href: `${BASE_URL}/acceptable-use` }],
  }),
});
